<template>
  <section>
    <div
      v-if="event.showDetails && checkStartTime"
      class="detailBox"
      :style="detailStyle"
    >
      <EventDetails :event="this.event" />
    </div>
    <div
      @click="showEventDetails()"
      class="calendarDayItem"
      v-if="checkStartTime"
    >
      <div class="calendarWeekItem" :style="style">
        <p>{{ event.title }}: {{ time }}</p>
      </div>
    </div>
    <div v-else class="emptyItem">
      <div class="blankCalendarItem" :style="blankStyle" v-if="checkBlank">
        <p>{{ event.title }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import EventDetails from "@/components/calendar/EventDetails";

export default {
  props: ["event", "day", "events", "hour", "index"],

  components: {
    EventDetails,
  },

  data: () => ({
    time: "",
  }),
  mounted() {
    const startTime = moment(this.event.startDate).format("h:mm a");
    const endTime = moment(this.event.endDate).format("h:mm a");
    const diff = this.event.endDate - this.event.startDate;
    if (diff == 0) {
      this.time = startTime;
    } else {
      this.time = startTime + " - " + endTime;
    }
  },

  computed: {
    ...mapState("calendar", ["showDetails"]),
    style() {
      const startTime = moment(this.event.startDate).format("hh:mm");
      var repeatCount = 0;
      var width = 8;
      for (let i = 0; i < this.hour.events.length; i++) {
        let tmpStartTime = moment(this.hour.events[i].startDate).format(
          "hh:mm"
        );
        if (tmpStartTime == startTime) {
          repeatCount++;
        }
      }
      var color = "";
      switch (this.event.type) {
        case "class":
          color = "#16a085";
          break;
        case "assessment":
          color = "#e74c3c";
          break;
        case "assignment":
          color = "#f39c12";
          break;
        case "office":
          color = "#0984e3";
          break;
        case "other":
          color = "#a55eea";
          break;
      }

      let diff = this.event.endDate - this.event.startDate;
      if (diff == 0) {
        diff = 35;
      } else {
        diff = diff / 35500;
      }

      var min = moment(this.event.startDate).format("m");
      var top = 60;
      if (min == 0) {
        top = 0;
      } else {
        top = min / 60;
      }

      return {
        "background-color": color,
        "margin-top": top * 50 + "px",
        height: diff / 1.8 + "px",
        right: width / (this.index * 1.5) + "vw",
        width: (width / repeatCount) * repeatCount + "vw",
      };
    },

    blankStyle() {
      const startTime = moment(this.event.startDate).format("hh:mm");
      var repeatCount = 0;
      var width = 8;
      for (let i = 0; i < this.hour.events.length; i++) {
        let tmpStartTime = moment(this.hour.events[i].startDate).format(
          "hh:mm"
        );
        if (tmpStartTime == startTime) {
          repeatCount++;
        }
      }
      return {
        width: width / repeatCount + "vw",
        "background-color": "#16a085",
      };
    },
    detailStyle() {
      let x = this.day.weekNum > 2 ? -100 : 32;
      let y = this.hour.hour > 20 ? -90 : 0;
      return {
        transform: "translate(" + x + "%, " + y + "%)",
      };
    },
    checkStartTime() {
      if (this.event.startDate) {
        const startTime = moment(this.event.startDate).format("HH");
        if (startTime == this.hour.hour) {
          return true;
        }
      }
      return false;
    },
    checkBlank() {
      if (this.event.startDate == null) {
        return true;
      }
      return false;
    },
  },

  methods: {
    getDateInMs(date) {
      return new Date(date).getTime();
    },

    showEventDetails() {
      this.event.showDetails = !this.event.showDetails;
      this.hidePreviousEventDetails(this.event);
    },

    hidePreviousEventDetails(event) {
      for (const index in this.events) {
        if (this.events[index] != event) {
          this.events[index].showDetails = false;
          this.$store.commit("calendar/setShowDetails", false);
        }
      }
    },

    setEventWeeks(startDate, endDate) {
      var startWeek = moment(startDate).week();
      var endWeek = moment(endDate).week();
      var weeks = [];
      for (var week = startWeek; week <= endWeek; week++) {
        weeks.push(week);
      }
      return weeks;
    },
  },
};
</script>

<style scoped>
p {
  color: white;
  font-size: 12px;
}

.emptyItem {
  padding: 10px 0px 10px;
  pointer-events: none;
}

.calendarItem {
  position: absolute;
  margin: 0 2px 2px 0px;
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  margin-top: -10px;
  z-index: 2;
}

.blankCalendarItem {
  position: absolute;
  border: 1px solid black;
  top: 20%;
  right: 0;
  margin: 0 2px 2px 0px;
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  margin-top: -10px;
  width: 8vw;
  z-index: 3;
  background-color: #e74c3c;
  height: 35%;
}

.calendarBlock {
  position: relative;
  background-color: transparent;
  margin: 0 2px 2px 0px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  z-index: 2;
}
.calendarWeekItem {
  border: 1px solid black;
  margin: 0 2px 2px 0px;
  border-radius: 5px;
  padding-left: 5px;
  text-align: start;
  cursor: pointer;
  transform: translateY(-10px);
  overflow: hidden;
  position: absolute;
}
.red {
  color: transparent;
}
</style>
